import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  data: {},
  optionsData: [],
  struConfigId: null,
  clientStoreHash: null,

};

export const getCategories = createAsyncThunk(
  "getCategories",
  async (data) => {
    try {
      const response = await fetch(`/api/getAllRootCategories/${data.configId}/${data.locale}`, {
        method: "GET",
        cache: "no-store",
      });
      if (!response.ok) {
        throw new Error("Failed to fetch config");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message);
    }
  }
);

const credentialsSlice = createSlice({
  name: "getCategories",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getCategories.pending, (state) => {
        state.status = "PIM loading";
        state.message = null;
      })
      .addCase(getCategories.fulfilled, (state, action) => {
        state.status = "PIM loaded";
        state.data = action.payload.data.data;

        const pindata = Object.entries(action.payload.data.data)?.map(([code, label]) => ({
          value:code,
          label: label
        }));
        state.optionsData = pindata
      })
      .addCase(getCategories.rejected, (state, action) => {
        state.status = "error";
        state.message = action.error.message;
      });
  },
});

export default credentialsSlice.reducer;
